import * as React from 'react';
import {FtButton} from "@/common/FtButton";

interface Props {
    todayLabel?: string;
    onToday: () => void;
    onPrev: () => void;
    onNext: () => void;
}

export function DateNav(props: Props) {
    const {todayLabel, onToday, onPrev, onNext} = props;

    return <div style={{display: "flex"}} className="button-group">
        <FtButton onClick={onPrev} variant="outlined">&lt; 이전</FtButton>
        <FtButton onClick={onToday} variant="outlined">{todayLabel ?? "이번달"}</FtButton>
        <FtButton onClick={onNext} variant="outlined">다음 &gt;</FtButton>
    </div>
}